import { FilterTable } from "../../../../../Components/FilterTable/FilterTable";
import { filters, headerColumns } from "./CloudZeroAssetColumns";
import { CloudZeroAssetRow, type CloudZeroAssetRowData } from "./CloudZeroAssetRow";

interface CloudZeroAssetTableProps {
  configs: CloudZeroAssetRowData[];
}

const CloudZeroAssetTable = ({ configs }: CloudZeroAssetTableProps) => {
  const rowWrapper = ({ row }: { row: CloudZeroAssetRowData }) => <CloudZeroAssetRow data={row} />;

  return (
    <FilterTable<CloudZeroAssetRowData>
      tableItems={configs}
      rowComponent={rowWrapper}
      headerColumns={headerColumns}
      filterColumns={filters}
      persistenceKey="CloudZeroAssetTable"
      data-cy="cloud-zero-asset-table"
    />
  );
};

export default CloudZeroAssetTable;
